<template>
  <v-card>
    <v-card-title class="headline py-2">
      {{(editMode)?'Редактировать':'Добавить'}} форму ввода
      <v-spacer></v-spacer>
      <v-btn icon class="mx-0" @click="$emit('close-dialog')"><v-icon>close</v-icon></v-btn>
    </v-card-title>
    <v-divider></v-divider>
    <v-card-text style="overflow-y: scroll">
      <v-tabs v-model="tab" slider-color="primary" color="panel" dark>
        <v-tab href="#params">Параметры</v-tab>
        <v-tab href="#lines">Объекты учета</v-tab>
        <v-tab href="#scope">Ответственные</v-tab>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item class="mt-2" value="params">
          <v-container grid-list-xl class="pa-0">
            <v-layout row wrap>
              <v-flex xs12>
                <v-text-field v-model="formObject.name" label="Название"></v-text-field>
              </v-flex>
              <v-flex xs12 class="py-0">
                <div class="mb-3">
                  <label class="v-label theme--light" style="font-size: 13px">Описание</label>
                  <dantser-editor v-model="formObject.description" :init="config" :api-key="apiKey"></dantser-editor>
                </div>
              </v-flex>
              <v-flex xs12>
                <dantser-tree
                  label="Родительская папка"
                  :source="foldersTree"
                  ref="parentFolder"
                  :field="true"
                  :selectMode="1"
                  @node-dblclick="setFolder($event)"
                >
                </dantser-tree>
              </v-flex>
            </v-layout>
          </v-container>
        </v-tab-item>
  
        <v-tab-item class="mt-2" value="lines">
          <v-treeview :items="objectsTree" item-key="key" class="densed pb-1" v-model="tree" selectable return-object>
            <template slot="prepend" slot-scope="{ item, open, leaf }">
              <v-icon size="20" class="mx-0" :color="item.iconcolor" @contextmenu="openMenu($event, item, 'object')">{{item.icon}}</v-icon>
            </template>
            <label slot="label" class="pointer" slot-scope="{item}" @click="" @contextmenu="openMenu($event, item, 'object')">{{item.name}}</label>
          </v-treeview>
        </v-tab-item>
        
        <v-tab-item class="mt-2" value="scope">
          <v-checkbox v-model="formObject.multiscope" label="Автоназначение объектов учета на отмеченные посты"></v-checkbox>
          <dantser-scope :treedata="treedata" v-model="formObject.scope"></dantser-scope>
        </v-tab-item>
      </v-tabs-items>
    </v-card-text>
    <v-divider></v-divider>
    <v-card-actions class="pa-3">
      <v-btn color="success" @click="submit" :disabled="status.btnDisabled">Сохранить</v-btn>
      <span :class="status.className" class="ml-2">{{status.text}}</span>
    </v-card-actions>
  </v-card>
</template>

<script>
  import {mapGetters, mapState} from 'vuex'
  import entities from '@/mixins/entities'
  
  export default {
    name : "InputForm",
  
    mixins: [entities],
    
    props:{
      data:{
        type: Object,
        required: false,
        default: () => { return {
          name: '',
          description: '',
          parent_id: null,
          multiscope: false,
          lines: [],
          scope: []
        }}
      },
      editMode: {
        type: Boolean,
        required: false,
        default: false
      }
    },
  
    computed:{
      ...mapState('analytics', {
        config: state => state.editorBaseConfig,
        apiKey: state => state.editorApiKey,
      }),
      ...mapGetters('app/org', ['getPostById','getContainerById']),
      ...mapState(`analytics/constructor`, ['objectsTree']),
    },
  
    created(){
      this.formObject = JSON.parse(JSON.stringify(this.data))
      this.getTrees()
      if(this.editMode){
        this.getFormInfo()
      }
    },
  
    data(){
      return {
        status:{
          btnDisabled: false,
          text: '',
          className:'success--text darken-1'
        },
        tab: null,
        formObject: {},
        treedata: [],
        foldersTree: [],
        tree: []
      }
    },
    
    methods:{
      getTrees(){
        this.$store.dispatch('app/org/tree', 'other').then(usersTree => {
          this.treedata = usersTree
        })
        
        this.$store.dispatch('analytics/constructor/getFoldersTree', {id: 0, type: 'form'}).then( response => {
          response.unshift({ id: 0, name: 'Не выбрано', icon: 'mdi mdi-square' })
          this.foldersTree = response
          this.$nextTick(function(){
            if(this.formObject.parent_id!=null){
              this.$refs['parentFolder'].setSelected(this.formObject.parent_id)
            } else {
              this.$refs['parentFolder'].setSelected(0)
            }
          })
        })
      },
  
      getFormInfo(){
        this.$store.dispatch('analytics/constructor/getForm', this.data.id).then( response => {
          this.formObject = response
          response.lines.map( id => {
            this.tree.push({key: 'o_'+id})
          })
          this.convertArrayobjects(this.formObject.scope, 'element_id')
        })
      },
  
      setFolder(eventData){
        this.formObject.parent_id = eventData.id
      },
  
      submit(){
        this.status={ btnDisabled: true, text: 'Сохранение', className:'secondary--text lighten-1' }
  
        if(this.editMode){
          this.$store.dispatch('analytics/constructor/updateForm', this.formObject).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
            this.$emit('close-dialog')
          }).catch( error => {
            this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
          })
        } else {
          this.$store.dispatch('analytics/constructor/createForm', this.formObject).then( response => {
            this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
            this.$emit('close-dialog')
          }).catch( error => {
            this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
          })
        }
      }
    },
    
    watch:{
      tree(val){
        this.formObject.lines = []
        val.map(item => {
          if(item.element_type==='object') this.formObject.lines.push(item.id)
        })
      }
    }
    
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/apps/analytics/components/Constructor/Forms/InputForm.vue